import { LocalDate } from "@js-joda/core";
import currency from "currency.js";
import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { Source } from "trader.ts/types/source";
import { dyn } from "trader.ts/ui";
import { Form, constantField, selectBox } from "trader.ts/ui.forms";
import {
  invoiceid,
  mollie_payment_id,
  paymentid,
  studentid,
} from "../../../sql/classy/types";
import * as style from "../../../styles/style.css.classes";
import { makeArrayField, oneLineArrayRender } from "../../client/arrayfield";
import { currencyBox } from "../../client/financialfields";
import { renderCancelButton, renderSaveButton } from "../../client/savebutton";
import { isNil } from "../../lib/istype";
import * as routes from "../../routes";
import { renderCurrency } from "../../render";

export function render(opts: {
  mollie_payment_id: mollie_payment_id;
  paymentsWithInvoicesAndSubjects: {
    paymentid: paymentid;
    payment_amount: currency;
    payment_date: LocalDate;

    invoiceid: invoiceid;
    invoice_total: currency;

    studentid: studentid;
    description: string;
  }[];
}): HTMLElement | HTMLElement[] {
  const editingS = new Source(false);

  return (
    <section className={style.card + style.card_accent} style="width: 100%;">
      {dyn(editingS, (editing) => {
        if (editing) {
          const form = new Form({})
            .addField("payments", [], async () => {
              const studentids = opts.paymentsWithInvoicesAndSubjects
                .map((p) => p.studentid)
                .uniq();
              const invoices = await rpc(
                routes.getPossibleInvoicesForOnlinePaymentSpec,
                undefined,
                { studentids },
              );
              return makeArrayField<{
                paymentid: null | paymentid;
                payment_amount: currency;
                invoice: { id: invoiceid; description: string };
              }>({
                initialVal: opts.paymentsWithInvoicesAndSubjects.map((p) => ({
                  paymentid: p.paymentid,
                  payment_amount: p.payment_amount,
                  invoice: {
                    id: p.invoiceid,
                    description: p.description,
                  },
                })),
                makeSubForm: async function (p) {
                  return new Form({})
                    .addField("paymentid", [], () => constantField(p.paymentid))
                    .addField("invoice", [], async () =>
                      !isNil(p.paymentid)
                        ? constantField(p.invoice, {
                            render: (
                              <div className={style.input_like}>
                                {p.invoice.description}
                              </div>
                            ),
                          })
                        : selectBox({
                            initial: undefined,
                            values: invoices,
                            show: (i) => i.description,
                          }),
                    )
                    .addField("payment_amount", [], () =>
                      currencyBox(p.payment_amount),
                    )
                    .build();
                },
                makeNew: function () {
                  return {
                    paymentid: null,
                    payment_amount: currency(0),
                    invoice: { id: -1 as invoiceid, description: "" },
                  };
                },
                render: oneLineArrayRender(
                  (r) => r.payment_amount.value === 0,
                  {
                    minimumOne: true,
                  },
                ),
              });
            })
            .build();
          return (
            <div>
              <section>
                <div className={style.equal_columns}>
                  <div>
                    <label for="">{"Classy betaling"}</label>
                  </div>
                  <div>
                    <label for="">{"Bedrag"}</label>
                  </div>
                </div>

                {form.render()}
              </section>

              <div style="text-align: right">
                {renderCancelButton({
                  onclick: () => editingS.set(false),
                })}
                {renderSaveButton({
                  formS: form.s,
                  save: async (f) => {
                    const res = await rpc(
                      routes.saveOnlinePaymentFullSpec,
                      undefined,
                      {
                        mollie_payment_id: opts.mollie_payment_id,
                        payments: f.payments,
                      },
                    );
                    return res;
                  },
                  reload: true,
                })}
              </div>
            </div>
          );
        } else {
          return (
            <div>
              <table>
                <tr>
                  <th>
                    {"Classy betalingen gekoppeld aan Mollie betaling"}
                  </th>
                  <th>{"Bedrag"}</th>
                </tr>
                {opts.paymentsWithInvoicesAndSubjects.map((p) => {
                  return (
                    <tr>
                      <td>
                        <a
                          href={routes.invoicedetailsRoute.link({
                            invoiceid: p.invoiceid,
                            edit: false,
                          })}
                        >
                          {p.description}
                        </a>
                      </td>
                      <td>{renderCurrency(p.payment_amount)}</td>
                    </tr>
                  );
                })}
              </table>
              <div style="text-align: right">
                <button onclick={() => editingS.set(true)}>
                  {"Pas aan"}
                </button>
              </div>
            </div>
          );
        }
      })}
    </section>
  );
}
